import React from 'react';
import { connect } from 'react-redux';

import { createComponent, Layout, Header, Button, Label, enums, PropTypes } from 'console-kit';
import authStatics from '../../../common/static';

import SendPasswordPanelActions from '../redux/actions';
import AuthImageLogo from '../../../components/AuthImageLogo';

const SendPasswordPanel = createComponent({
  displayName: 'SendPasswordPanel',
  propTypes:   {
    loginLink: PropTypes.string,
  },
  defaultProps: {
    loginLink: undefined,
  },
  handlers: {
    handleClick: p => (e, { value }) => {
      p.onSendPasswordRequestClicked();
      window.location.href = '/';
    },
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Thanks"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text="We've sent you an email to help you reset your password."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <If condition={props.loginLink}>
            <Layout.Row>
              <Button.WithAnimation
                actions={{
                  start:   SendPasswordPanelActions.onSendPasswordRequest,
                  success: SendPasswordPanelActions.onSendPasswordSuccess, //no action
                  failure: SendPasswordPanelActions.onSendPasswordFailure, //no action
                }}
              >
                <Button.Primary
                  text="Login"
                  float={enums.positions.RIGHT}
                  size={enums.sizes.X4}
                  onClick={props.handleClick}
                  textAlign={enums.textAlignments.CENTER}
                  color={enums.colors.ACCENT}
                  isSolid
                  isFluid
                  isDisabled={false}
                />
              </Button.WithAnimation>
            </Layout.Row>
          </If>
        </Layout>
      </div>
    );
  },
});

export default connect(null, dispatch => ({
  onSendPasswordRequestClicked() {
    dispatch(SendPasswordPanelActions.onSendPasswordRequest());
  },
}))(SendPasswordPanel);
